import { MODE, API_URL_DEV, API_URL_PRO } from "../config";

const API_URL = MODE === "LOCALHOST" ? API_URL_DEV : API_URL_PRO;

export const getProductsService = async () => {
  try {
    const res = await fetch(
      `${API_URL}anonymous/help/offer/productsmexusa`,
      {
        mode: "no-cors",
      }
    );
    const contentType = res.headers.get("Content-Type");
    const isJSON = /json/.test(contentType);
    if (!isJSON) {
      return Promise.reject({
        error: true,
      });
    }
    return res.json();
  } catch (err) {
    return err;
  }
};
